var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStudentLoan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1636 27.4925C24.0774 27.4925 23.9924 27.475 23.9124 27.44L18.7038 25.1488C18.4776 25.0488 18.3301 24.8251 18.3301 24.5763C18.3301 24.3276 18.4763 24.1038 18.7038 24.0038L23.9124 21.7127C24.0724 21.6427 24.2561 21.6427 24.4161 21.7127L29.6247 24.0038C29.851 24.1038 29.9972 24.3276 29.9972 24.5763C29.9972 24.8251 29.851 25.0488 29.6235 25.1488L24.4149 27.44C24.3361 27.475 24.2499 27.4925 24.1636 27.4925Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9223 28.591C24.6798 28.6973 24.4274 28.7498 24.1674 28.7498C23.9074 28.7498 23.6549 28.6973 23.4149 28.5923L20 27.0898V27.6636C20 28.1723 20.2662 28.6498 20.6925 28.9098C21.8937 29.6373 23.0299 30.0023 24.1661 30.0023C25.3023 30.0023 26.4385 29.6373 27.6398 28.9098C28.0672 28.6498 28.3322 28.1723 28.3322 27.6636V27.0898L24.9223 28.591Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4962 18.3335C15.1988 18.3335 13.3301 16.4648 13.3301 14.1674C13.3301 11.8699 15.1988 10 17.4962 10C19.7936 10 21.6623 11.8687 21.6623 14.1661C21.6623 16.4635 19.7936 18.3335 17.4962 18.3335Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 24.5836C16.666 23.6749 17.1998 22.8499 18.0322 22.4837L22.8483 20.3587C22.3659 20.125 21.8246 20 21.2496 20H13.7499C11.6837 20 10 21.6837 10 23.7499V27.0835C10 27.316 10.1837 27.4998 10.4162 27.4998H18.3322V26.8085L18.0322 26.6748C17.1998 26.3085 16.666 25.4836 16.666 24.5836Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStudentLoan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_student_loan.6827bdf07c310d164d519baf1351a236.svg";